import { reactive } from "vue";

const theme = reactive({
  agentLogo: "",
  devLogo: "logo.png",
  apiUrl: "https://api.metaluxe.com.au/",
  bunnyApiUrl: "https://api.bunny.net/",

  streamToken: "2d5c56ec-04a8-4fb0-94ec-6e8fd5b1d436",
  videoLibraryId: "372826",
  streamCdnUrl: "https://vz-004324cf-29e.b-cdn.net",
  streamApiKey: "afc5e01d-1def-4e45-91ccf02c7121-0b95-4f4f",

  storageApiPassword: "87894d5b-5df4-4045-950b24d4050a-637c-4cdd",
  cdnUrl: "https://jardinia.b-cdn.net",
  devFolder: "/jardinia",

  videosIcon: "/img/ui-theme/videos-icon.svg",
  rendersIcon: "/img/ui-theme/renders-icon.svg",
  rangeIcon: "/img/ui-theme/range-icon.svg",
  panoramasIcon: "/img/ui-theme/panoramas-icon.svg",
  floorplansIcon: "/img/ui-theme/floorplans-icon.svg",
  dashboardMp4: "/theme/dashboard/background-4k.mp4",

  // top level menu
  assetsMenuOrder: ["Type-A"],

  typeAMenuOrder: ["videos", "virtual-tour", "balcony-views"],

  typeBMenuOrder: ["videos", "virtual-tour", "balcony-views", "floorplans"],

  typeCMenuOrder: ["videos", "virtual-tour", "balcony-views", "floorplans"],

  amenitiesMenuOrder: ["videos", "virtual-tour"],

  exteriorMenuOrder: ["videos"],

  typeAAsset: {
    videos: [],
    videosName: [],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
    panoramas: [0],
    panoramasName: "Type A",
    balconyUrl: ["https://storage.net-fs.com/hosting/7566552/30/"],
    virtualTourUrl: ["https://storage.net-fs.com/hosting/7566552/29/48547"],
    renders: [],
  },

  typeCAsset: {
    videos: [0, 1],
    videosName: ["Walkthrough", "Cinematic"],
    panoramas: [0],
    panoramasName: ["Type C"],
    panoramasUrl: ["https://app.cloudpano.com/tours/FxZKKTooTY6e?mls=1"],
    floorplans: [0, 1],
    floorplansName: ["Type C", "Type C Courtyard"],
    floorplansUrl: [""],
    balcony: [0],
    balconyName: ["Balcony Views"],
    balconyUrl: [
      "https://Jardiniabalconyviews.metaluxe.com.au/typec/index.htm",
    ],
  },
});

export default { theme };
